'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = undefined;

var _renderUtils = require('@wix/photography-client-lib/dist/src/utils/renderUtils');

var _renderUtils2 = _interopRequireDefault(_renderUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //import _ from 'lodash';
//import * as _ from 'lodash';
//import URI from 'urijs';
//import axios from 'axios';


//import watermarkApi from '@wix/photography-client-lib/dist/src/store/watermarkApi';
//import Wix from '@wix/photography-client-lib/dist/src/sdk/WixSdkWrapper';

var Utils = function (_RenderUtils) {
  _inherits(Utils, _RenderUtils);

  /* @ngInject */
  function Utils() {
    _classCallCheck(this, Utils);

    return _possibleConstructorReturn(this, _RenderUtils.call(this));
  }

  return Utils;
}(_renderUtils2.default);

var utils = exports.utils = new Utils();